module.exports = __webpack_public_path__ + "img/vinExample.17eef592.svg";